export const messages = {
  en: {
    integralWithdrawal: {
      queryCondition: 'Query Conditions',
      title: 'Integral Withdrawal',
      placeholder: {
        integralName: 'Please enter account name',
        amount: 'Please enter withdrawal amount',
        applyUserName: 'Please enter applicant name',
        applyUserTel: 'Please enter applicant phone'
      },
      table: {
        id: 'ID',
        integralId: 'Integral ID',
        integralName: 'Account Name',
        shopId: 'Shop ID',
        amount: 'Amount',
        applyUserName: 'Applicant',
        applyUserTel: 'Applicant Phone',
        bankNum: 'Bank Account',
        bankNumName: 'Account Name',
        bankName: 'Bank Name',
        remark: 'Application Note',
        stateName: 'Status',
        stateMsg: 'Audit Note'
      },
      audit: {
        title: 'Audit Withdrawal',
        integralName: 'Account Name',
        bankName: 'Bank Name',
        bankNumName: 'Account Name',
        bankNum: 'Bank Account',
        applyUserName: 'Applicant',
        applyUserTel: 'Applicant Phone',
        amount: 'Withdrawal Amount',
        remark: 'Application Note',
        state: 'Status',
        selectState: 'Please select status',
        stateMsg: 'Audit Note',
        stateMsgPlaceholder: 'Please enter audit note',
        stateRequired: 'Please select audit status',
        stateMsgRequired: 'Please enter audit note when rejected',
        stateOptions: {
          approved: 'Approved',
          rejected: 'Rejected'
        }
      }
    }
  },
  zh: {
    integralWithdrawal: {
      queryCondition: '查询条件',
      title: '积分提现',
      placeholder: {
        integralName: '请输入账户名称',
        amount: '请输入提现金额',
        applyUserName: '请输入申请人姓名',
        applyUserTel: '请输入申请人电话'
      },
      table: {
        id: '编号',
        integralId: '积分ID',
        integralName: '账户名称',
        shopId: '商铺编号',
        amount: '提现金额',
        applyUserName: '申请人',
        applyUserTel: '申请人电话',
        bankNum: '银行账户',
        bankNumName: '账户名称',
        bankName: '开户行',
        remark: '申请说明',
        stateName: '状态',
        stateMsg: '审核说明'
      },
      audit: {
        title: '审核提现',
        integralName: '账户名称',
        bankName: '开户行',
        bankNumName: '账户名称',
        bankNum: '银行账户',
        applyUserName: '申请人',
        applyUserTel: '申请人电话',
        amount: '提现金额',
        remark: '申请说明',
        state: '状态',
        selectState: '请选择审核状态',
        stateMsg: '审核说明',
        stateMsgPlaceholder: '请输入审核说明',
        stateRequired: '请选择审核状态',
        stateMsgRequired: '拒绝时必须填写审核说明',
        stateOptions: {
          approved: '同意并已打款',
          rejected: '拒绝'
        }
      }
    }
  }
}